import { useCallback, useEffect, useRef } from 'react';

export type UseDebounceReturn = [
  () => void,
  () => void,
];

export function useDebounce(
  predicate: () => void,
  delay = 300,
): UseDebounceReturn {
  const timeout = useRef<ReturnType<typeof setTimeout>>();
  const callback = useRef(predicate);

  const set = useCallback(() => {
    timeout.current && clearTimeout(timeout.current);

    timeout.current = setTimeout(() => {
      callback.current();
    }, delay);
  }, [delay]);

  const clear = useCallback(() => {
    timeout.current && clearTimeout(timeout.current);
  }, []);

  useEffect(() => {
    callback.current = predicate;
  }, [predicate]);

  useEffect(() => {
    return clear;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay]);

  return [set, clear];
}
